import { render, staticRenderFns } from "./Agentkbank.vue?vue&type=template&id=ee59fdbe"
import script from "./Agentkbank.vue?vue&type=script&lang=js"
export * from "./Agentkbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports